import { render, staticRenderFns } from "./EmailOfferDeliverance.vue?vue&type=template&id=9df76f68&scoped=true&lang=pug&"
import script from "./EmailOfferDeliverance.vue?vue&type=script&lang=js&"
export * from "./EmailOfferDeliverance.vue?vue&type=script&lang=js&"
import style0 from "./EmailOfferDeliverance.vue?vue&type=style&index=0&id=9df76f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df76f68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VChip,VCol,VDivider,VForm,VRow,VTextField})
